import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchProducts } from '../lib/api';

const ProductContext = createContext({ products: [], loading: true });

export function ProductProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts().then(data => {
      if (data && data.length > 0) setProducts(data);
      setLoading(false);
    });
  }, []);

  return (
    <ProductContext.Provider value={{ products, loading }}>
      {children}
    </ProductContext.Provider>
  );
}

export const useProducts = () => useContext(ProductContext);
